import React, { useState } from 'react'
import NumericKeyPad from '../../components/numeric_keypad/NumericKeyPad'
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';
import { AuthFetchAPI } from '../../api/Auth';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import LoadingAlert from '../../components/Alerts/LoadingAlert';

import logo from '../../components/img/logos/logo.png'

import codepin from './img/icons/codigo-pin.png'


function VendingModalKeyCode({ codeSesion, setCodeSesion, authMachineVending, showModalKeyCode, setShowModalKeyCode }) {
   //state of keypad number
   const [displayNumber, setDisplayNumber] = useState('');
   const [nameButton, setNameButton] = useState({ button: "Siguiente", title: "empresa" });


   //set code's of the sesion 
   const handleSaveCode = () => {
      if (codeSesion.business_code == "0000") {
         codeSesion.business_code = displayNumber;

         setDisplayNumber('')//clear input of the keypad
         nameButton.button = 'Siguiente';
         nameButton.title = 'Sucursal'

      } else if (codeSesion.branchoffice_code == "0000") {
         codeSesion.branchoffice_code = displayNumber;

         setDisplayNumber('')//clear input of the keypad
         nameButton.button = 'Iniciar sesion';
         nameButton.title = 'Máquina'

      } else if (codeSesion.machine_code == "0000") {
         codeSesion.machine_code = displayNumber;
         LoadingAlert()
         setDisplayNumber('') //clear input of the keypad
         authMachineVending()
         nameButton.button = 'Siguiente';
         nameButton.title = 'Empresa'
      }
   }

   //reset data of the sesion
   const handleClearAllData = () => {
      nameButton.button = 'Siguiente'
      setCodeSesion({ business_code: "0000", branchoffice_code: "0000", machine_code: "0000", });
      setDisplayNumber('');
      Swal.fire({
         title: 'Se han borrado todos los datos de sesión. Por favor, ingrese nuevamente.',
         imageUrl: 'https://4.bp.blogspot.com/-BSVi3LL3KAY/UtcAHycLOeI/AAAAAAAAicg/gw1LjfAzHz4/s1600/barrer+gregar+blogdeimagenes+(3).gif',
         imageWidth: 400,
         imageHeight: 400,
         timer: 4000,
         showConfirmButton: false,
         imageAlt: 'Clean image',
      })
   }

   // Helper: oculta el código con asteriscos
   const maskCode = (code) => {
      if (!code || code === '0000') return '0000';
      return '•'.repeat(code.length); // o usa '*' si prefieres asteriscos
   };

   return (
      <>
         <Modal
            show={showModalKeyCode}
            fullscreen
            onHide={() => setShowModalKeyCode(false)}>
            <Modal.Body className='m-0 p-0'>


               <div className="vmk2-root">

                  {/* Halo de fondo azul */}
                  <div className="vmk2-halo" />

                  {/* ========== HEADER FIJO ========== */}
                  <header className="vmk2-header">
                     <button
                        className="vmk2-back-btn"
                        onClick={() => (setShowModalKeyCode(false))}
                        aria-label="Volver"
                        title="Volver"
                     >
                        <i className="uil uil-arrow-left"></i>
                     </button>

                     <div className="vmk2-header-title-wrap">
                        <span className="vmk2-header-eyebrow">Validación</span>
                        <h1 className="vmk2-header-title">
                           Código de
                           <em> {nameButton.title}</em>
                        </h1>
                     </div>

                     {/* Logo / imagen */}
                     <div className="vmk2-logo-frame">
                        <img className="vmk2-logo" src={codepin} alt="Smart Pay" />
                     </div>
                  </header>

                  {/* ========== CENTRO ========== */}
                  <main className="vmk2-main">

                     {/* Stepper: 3 códigos visualmente progresivos */}
                     <section className="vmk2-stepper">

                        {/* Step 1: Empresa */}
                        <div
                           className={`vmk2-step ${codeSesion.business_code !== '0000' ? 'is-completed' :
                              nameButton.title === 'empresa' ? 'is-active' : ''
                              }`}
                        >
                           <div className="vmk2-step-marker">
                              {codeSesion.business_code !== '0000' ? (
                                 <i className="uil uil-check"></i>
                              ) : (
                                 <span>1</span>
                              )}
                           </div>
                           <div className="vmk2-step-info">
                              <span className="vmk2-step-label">Empresa</span>
                              {/* <span className={`vmk2-step-code ${codeSesion.business_code !== '0000' ? 'is-filled' : ''}`}>
                                 {codeSesion.business_code}
                              </span> */}

                              <span className={`vmk2-step-code ${codeSesion.business_code !== '0000' ? 'is-filled' : ''}`}>
                                 {maskCode(codeSesion.business_code)}
                              </span>
                           </div>
                        </div>

                        <div className="vmk2-step-connector" />

                        {/* Step 2: Sucursal */}
                        <div
                           className={`vmk2-step ${codeSesion.branchoffice_code !== '0000' ? 'is-completed' :
                              nameButton.title === 'Sucursal' ? 'is-active' : ''
                              }`}
                        >
                           <div className="vmk2-step-marker">
                              {codeSesion.branchoffice_code !== '0000' ? (
                                 <i className="uil uil-check"></i>
                              ) : (
                                 <span>2</span>
                              )}
                           </div>
                           <div className="vmk2-step-info">
                              <span className="vmk2-step-label">Sucursal</span>
                              {/* <span className={`vmk2-step-code ${codeSesion.branchoffice_code !== '0000' ? 'is-filled' : ''}`}>
                                 {codeSesion.branchoffice_code}
                              </span> */}

                              <span className={`vmk2-step-code ${codeSesion.branchoffice_code !== '0000' ? 'is-filled' : ''}`}>
                                 {maskCode(codeSesion.branchoffice_code)}
                              </span>
                           </div>
                        </div>

                        <div className="vmk2-step-connector" />

                        {/* Step 3: Máquina */}
                        <div
                           className={`vmk2-step ${codeSesion.machine_code !== '0000' ? 'is-completed' :
                              nameButton.title === 'Máquina' ? 'is-active' : ''
                              }`}
                        >
                           <div className="vmk2-step-marker">
                              {codeSesion.machine_code !== '0000' ? (
                                 <i className="uil uil-check"></i>
                              ) : (
                                 <span>3</span>
                              )}
                           </div>
                           <div className="vmk2-step-info">
                              <span className="vmk2-step-label">Máquina</span>
                              {/* <span className={`vmk2-step-code ${codeSesion.machine_code !== '0000' ? 'is-filled' : ''}`}>
                                 {codeSesion.machine_code}
                              </span> */}

                              <span className={`vmk2-step-code ${codeSesion.machine_code !== '0000' ? 'is-filled' : ''}`}>
                                 {maskCode(codeSesion.machine_code)}
                              </span>
                           </div>
                        </div>
                     </section>

                     {/* Numeric Keypad (componente separado) */}
                     <section className="vmk2-keypad-wrap">
                        <NumericKeyPad
                           displayNumber={displayNumber}
                           setDisplayNumber={setDisplayNumber}
                        />
                     </section>
                  </main>

                  {/* ========== FOOTER FIJO ========== */}
                  <footer className="vmk2-footer">
                     <button
                        className="vmk2-save-btn"
                        onClick={() => (handleSaveCode())}
                        disabled={!displayNumber || displayNumber.length === 0}
                     >
                        <i className="uil uil-check-circle"></i>
                        <span>{nameButton.button}</span>
                     </button>
                  </footer>
               </div>

               {/* <main className='keyboard-main h-100 d-flex align-items-center '>
                  <div className=' d-flex flex-column bd-highlight container'>
         
                     <section className='bd-highlight my-5'>
                        <h2 className="keyboard-title">Ingrese el código de {nameButton.title}</h2>
                     </section>
                     <section className='keyboard-steps bd-highlight w-100 row g-3'>
                        <div className={codeSesion.business_code != '0000' ? 'col-4 keyboard-step bg-light' : 'col-4 keyboard-step'}>
                           <h3 className={codeSesion.business_code != '0000' ? 'keyboard-steps-label text-center text-muted' : 'keyboard-steps-label text-center text-muted opacity-25'}>
                              Código Empresa
                           </h3>
                           <p
                              className={
                                 codeSesion.business_code != '0000'
                                    ? 'keyboard-steps-number keyboard-steps-number-active text-center '
                                    : 'keyboard-steps-number text-center text-muted opacity-25'}>
                              {codeSesion.business_code}

                           </p>
                        </div>
                        <div className={codeSesion.branchoffice_code != '0000' ? 'col-4 keyboard-step bg-light' : 'col-4 keyboard-step'}>
                           <h3 className={codeSesion.branchoffice_code != '0000' ? 'keyboard-steps-label text-center text-muted' : 'keyboard-steps-label text-center text-muted opacity-25'}>Código Sucursal</h3>
                           <p className={codeSesion.branchoffice_code != '0000' ? 'keyboard-steps-number keyboard-steps-number-active text-center ' : 'keyboard-steps-number text-center text-muted opacity-25'}>{codeSesion.branchoffice_code}</p>
                        </div>
                        <div className={codeSesion.machine_code != '0000' ? 'col-4 keyboard-step bg-light' : 'col-4 keyboard-step'}>
                           <h3 className={codeSesion.machine_code != '0000' ? 'keyboard-steps-label text-center text-muted' : 'keyboard-steps-label text-center text-muted opacity-25'}>Código Sucursal</h3>
                           <p className={codeSesion.machine_code != '0000' ? 'keyboard-steps-number keyboard-steps-number-active text-center ' : 'keyboard-steps-number text-center text-muted opacity-25'}>{codeSesion.machine_code}</p>
                        </div>
                     </section>
                     <section className='bd-highlight w-100'>
                        <NumericKeyPad displayNumber={displayNumber} setDisplayNumber={setDisplayNumber} />
                     </section>
                     <section className='bd-highlight row'>           
                        <div className='col-12'><button type="button" className=" btn btn-lg btn-vending btn-vending-success w-100" onClick={() => (handleSaveCode())}>
                        <i className="uil uil-arrow-right"></i> {nameButton.button}
                        </button></div>
                     </section>
                  </div>
               </main> */}
            </Modal.Body>
            {/* <Modal.Footer className='d-flex justify-content-start m-0 p-0'>


            </Modal.Footer> */}
         </Modal>

      </>
   )
}

export default VendingModalKeyCode